/**
 * Eiferer Dark Theme — Scroll Animations & Interactions
 * 
 * HOW TO USE:
 * 1. Upload this file to your theme's /assets folder
 * 2. Add the following in layout/theme.liquid before </body>:
 *    <script src="{{ 'eiferer-animations.js' | asset_url }}" defer></script>
 */

(function() {
  'use strict';

  // ─── Scroll-triggered fade-in ───
  const fadeObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          // Stagger the animation for sibling elements
          const parent = entry.target.parentElement;
          const siblings = parent ? Array.from(parent.querySelectorAll('.eif-fade-in')) : [];
          const siblingIndex = siblings.indexOf(entry.target);
          const delay = siblingIndex >= 0 ? siblingIndex * 80 : 0;

          setTimeout(() => {
            entry.target.classList.add('eif-visible');
          }, delay);

          fadeObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    }
  );

  // Observe all fade-in elements
  function initFadeAnimations() {
    document.querySelectorAll('.eif-fade-in').forEach((el) => {
      fadeObserver.observe(el);
    });
  }

  // ─── Sticky nav background on scroll ───
  function initStickyNav() {
    const header = document.querySelector('.shopify-section-header');
    if (!header) return;

    let lastScroll = 0;

    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll > 20) {
        header.classList.add('shopify-section-header-sticky');
      } else {
        header.classList.remove('shopify-section-header-sticky');
      }

      lastScroll = currentScroll;
    }, { passive: true });
  }

  // ─── Product card hover glow effect ───
  function initCardGlow() {
    document.querySelectorAll('.card-wrapper, .eif-cat-tile, .eif-card').forEach((card) => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        card.style.setProperty('--mouse-x', `${x}px`);
        card.style.setProperty('--mouse-y', `${y}px`);
      });
    });
  }

  // ─── Initialize on DOM ready ───
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initFadeAnimations();
    initStickyNav();
    initCardGlow();

    // Re-init after Shopify section rendering (theme editor)
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => {
        initFadeAnimations();
        initCardGlow();
      });
    }
  }
})();
